import { render, staticRenderFns } from "./ProductsPlanet.vue?vue&type=template&id=2176159a"
import script from "./ProductsPlanet.vue?vue&type=script&lang=js"
export * from "./ProductsPlanet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports